/**
 * Stable CSS class names for E2E — Product detail page.
 */
export const PRD = {
    page: 'product-detail-page',
    breadcrumbSection: 'product-detail-page__breadcrumb-section',

    cardPaper: 'product-detail-page__card-paper',
    layout: 'product-detail-page__layout',

    leftPanel: 'product-detail-page__left-panel',
    rightPanel: 'product-detail-page__right-panel',

    leftHeaderRow: 'product-detail-page__left-header-row',
    purchasableChip: 'product-detail-page__purchasable-chip',
    seasonCode: 'product-detail-page__season-code',
    productTitle: 'product-detail-page__product-title',

    imageCard: 'product-detail-page__image-card',
    productImage: 'product-detail-page__product-image',
    colorChip: 'product-detail-page__color-chip',

    infoRowsCard: 'product-detail-page__info-rows-card',
    sizeChipsSection: 'product-detail-page__size-chips-section',
    sizeChip: 'product-detail-page__size-chip',

    mannequinTableWrap: 'product-detail-page__mannequin-table-wrap',
    actionButtonsRow: 'product-detail-page__action-buttons-row',
    showOnSiteButton: 'product-detail-page-input--button-show-on-site',
    teknikFoyButton: 'product-detail-page-input--button-teknik-foy',

    tabs: 'product-detail-page__tabs',
    tabPanelProductContent: 'product-detail-page__tab-panel--product-content',
    tabPanelStockInfo: 'product-detail-page__tab-panel--stock-info',
    tabPanelComments: 'product-detail-page__tab-panel--comments',
    tabPanelStoreStock: 'product-detail-page__tab-panel--store-stock',
    tabPanelProductSizeInfo: 'product-detail-page__tab-panel--product-size-info',

    refreshStockButton: 'product-detail-page-input--button-refresh-stock',
    stockGridWrap: 'product-detail-page__stock-grid-wrap',
    commentsGridWrap: 'product-detail-page__comments-grid-wrap',

    storeStockHeaderRow: 'product-detail-page__store-stock-header-row',
    openStoreFilterButton: 'product-detail-page-input--button-open-store-filter',
    selectedFiltersRow: 'product-detail-page__selected-filters-row',
    selectedCityChip: 'product-detail-page-input--chip-selected-city',
    selectedCountyChip: 'product-detail-page-input--chip-selected-county',
    selectedSizeChip: 'product-detail-page-input--chip-selected-size',

    storeFilterDrawerPaper: 'product-detail-page__store-filter-drawer-paper',
    storeFilterDrawerContent: 'product-detail-page__store-filter-drawer-content',

    storeGridWrap: 'product-detail-page__store-grid-wrap',
    storeMapButton: 'product-detail-page-input--button-view-on-map',
    emptyNoDataWrap: 'product-detail-page__empty-no-data-wrap',
} as const;

export const prdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
